import React, { useState } from "react";
import Header from "../header/header";
import appStyles from "./app.module.css";
import HomePage from "../../pages/home";
import Splashscreen from "../splashscreen/splashscreen";

function App() {
  const [isLoad, setIsLoad] = useState(false);

  setTimeout(() => {
    setIsLoad(true);
  }, 6000);

  return (
    <div className={appStyles.app}>
      {isLoad ? (
        <>
          <Header />
          <HomePage />
        </>
      ) : (
        <Splashscreen />
      )}
    </div>
  );
}

export default App;
